import { Loader } from "lucide-react";

export default function LoginLoader() {
    return (
        <div className="loginContainer">
            <div className="loginForm">
                <Loader />
            </div>
      </div>
    )
}